// One place for the WhatsApp numbers and the pre-filled first message.
//
// The message always says where the visitor came from ("I'm in Zambia…",
// "…from the Pricing page"), so the team can tag each chat with its country
// or page in VEC_MS and see which countries and pages are working. There is
// no analytics tool on the site; this message is the tracking.
import countryPages from '../content/countryPages.json';

export const WHATSAPP_NUMBERS = [
  { id: 'turkey', label: 'Turkey', display: '+90 552 811 7433', wa: '905528117433' },
  { id: 'zimbabwe', label: 'Zimbabwe', display: '+263 71 613 9559', wa: '263716139559' },
];

export const COUNTRY_PAGE_PREFIX = '/study-in-turkey-from-';

const PAGE_LABELS = [
  ['/', 'Home'],
  ['/pricing', 'Pricing'],
  ['/about', 'About'],
  ['/services', 'Services'],
  ['/universities', 'Universities'],
  ['/programs', 'Programs'],
  ['/scholarships', 'Scholarships'],
  ['/destinations', 'Destinations'],
  ['/become-an-agent', 'Become an Agent'],
  ['/blog', 'Blog'],
  ['/announcements', 'Announcements'],
  ['/consultation', 'Consultation'],
  ['/sign-up', 'Sign Up'],
];

export function countryForPath(pathname = '') {
  if (!pathname.startsWith(COUNTRY_PAGE_PREFIX)) return null;
  const slug = pathname.slice(COUNTRY_PAGE_PREFIX.length).replace(/\/$/, '');
  return countryPages.countries.find((c) => c.slug === slug) || null;
}

function pageLabelForPath(pathname = '/') {
  const exact = PAGE_LABELS.find(([path]) => path === pathname);
  if (exact) return exact[1];
  const section = PAGE_LABELS.find(([path]) => path !== '/' && pathname.startsWith(`${path}/`));
  return section ? section[1] : null;
}

/** The first message for a WhatsApp chat started on `pathname`. */
export function whatsappMessage(pathname = '/', extra = '') {
  const country = countryForPath(pathname);
  let message;
  if (country) {
    message = `Hi VisionExploit, I'm in ${country.name} and I'd like to study in Turkey.`;
  } else {
    const page = pageLabelForPath(pathname);
    message = page
      ? `Hi VisionExploit, I'd like to study in Turkey (from the ${page} page).`
      : 'Hi VisionExploit, I would like to study in Turkey.';
  }
  return extra ? `${message} ${extra}` : message;
}

export function whatsappUrl(pathname = '/', { number = WHATSAPP_NUMBERS[0].wa, extra = '' } = {}) {
  return `https://wa.me/${number}?text=${encodeURIComponent(whatsappMessage(pathname, extra))}`;
}

/** wa.me link with a message written by the caller (e.g. the agent form). */
export function whatsappUrlWithText(text, number = WHATSAPP_NUMBERS[0].wa) {
  return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
}
